import { buildUrl } from './Utils'
/* -------------------------------------------------------------------------- */
/*                          MANAGE PUBLIC APPLICATION                         */
/* -------------------------------------------------------------------------- */

export const NEW_PUBLIC_APPLICATION = (applicationId?: string): string => {
  return buildUrl(`/api/public/applications/${applicationId ? `${applicationId}/` : ''}`)
}

export const COMPLETE_PUBLIC_APPLICATION = (applicationId?: string): string => {
  return buildUrl(`/api/public/applications/${applicationId ? `${applicationId}/complete/` : ''}`)
}

export const TAKE_BOOKING = (applicationId: string): string => {
  return buildUrl(`/api/public/bookings/?application_id=${applicationId}`)
}

export const PUBLIC_QUALIFICATION = (assetId?: string): string => {
  return buildUrl(`/api/public/assets/${assetId}/qualification/`)
}

export const PUBLIC_APPLICATION = (applicationId: string): string => {
  return buildUrl(`/api/public/applications/${applicationId}/`)
}

export const PUBLIC_APPLICATION_INTEREST = (applicationId: string): string => {
  return buildUrl(`/api/public/applications/${applicationId}/interest/`)
}

export const DELETE_PUBLIC_APPLICATION = (applicationId: string): string => {
  return buildUrl(`/api/public/applications/${applicationId}/delete/`)
}

export const REQUEST_CODE_PUBLIC_APPLICATION = (applicationId: string): string => {
  return buildUrl(`/api/public/applications/${applicationId}/request_code/`)
}

/* -------------------------------------------------------------------------- */
/*                              UPLOAD / DOWNLOAD                             */
/* -------------------------------------------------------------------------- */

/**
 * Public
 * @description Files upload / download
 */

export const UPLOAD_URL = (applicationId: string, fileName?: string): string =>
  buildUrl(
    `/api/public/applications/${applicationId}/uploads/${fileName ? `?filename=${fileName}` : ''}`
  )

export const PUBLIC_DOWNLOAD_URL = (applicationId: string): string =>
  buildUrl(`/api/public/applications/${applicationId || ''}/files/`)
/**
 * Public
 * @description Get application booking
 */
export const GET_APPLICATION_BOOKING = (applicationId: string): string =>
  buildUrl(`/api/public/bookings/?application_id=${applicationId}`)

/* -------------------------------------------------------------------------- */
/*                               DOSSIER FACILE                               */
/* -------------------------------------------------------------------------- */

export const GET_DOSSIER_FACILE_REDIRECT_URL = (applicationId: string): string =>
  buildUrl(`/api/public/dossier_facile/login/?application_id=${applicationId}`)

export const GET_DOSSIER_FACILE_ACCOUNT_URL = (): string =>
  buildUrl(`/api/public/dossier_facile/account/`)
